import React, { Fragment, FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import { EWARRANT_ROUTE } from '../../constants';
import EWarrantList from './containers/EWarrantList';
import EWarrantView from './containers/EWarrantView';

interface Props {}

const EWarrant: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={EWARRANT_ROUTE}>
        <EWarrantList />
      </Route>
      <Route exact path={`${EWARRANT_ROUTE}/view`}>
        <EWarrantView />
      </Route>
    </Fragment>
  );
};

export default EWarrant;
